import TripDetails from './TripDetails';

export default TripDetails;
